/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/grading';

type Props = {
  total: number;
  isTeamAssignment: boolean;
};

const styles = {
  container: css`
    margin: var(--cds-spacing-200) 0;
  `,
};

// Component for the title appropriate for the grading flow
const GradingFlowTitle = ({ total, isTeamAssignment }: Props) => {
  return (
    <div css={styles.container}>
      <Typography2 component="h3" variant="subtitleMedium">
        {isTeamAssignment ? (
          <FormattedMessage
            message={_t('{numOfSubmitters, plural, =1 {Team} other {Teams}} {numOfSubmittersComponent}')}
            numOfSubmitters={total}
            numOfSubmittersComponent={
              <Typography2 variant="bodyPrimary" component="span">
                ({total})
              </Typography2>
            }
          />
        ) : (
          <FormattedMessage
            message={_t('{numOfSubmitters, plural, =1 {Learner} other {Learners}} {numOfSubmittersComponent}')}
            numOfSubmitters={total}
            numOfSubmittersComponent={
              <Typography2 variant="bodyPrimary" component="span">
                ({total})
              </Typography2>
            }
          />
        )}
      </Typography2>
    </div>
  );
};

export default GradingFlowTitle;
